export default __webpack_public_path__ + "static/media/europa_dark.c118d73e.png";